import {
  ADD_NOTIFICATION,
  CHART_STATE_SET,
  FORWARDINGS_SET,
  REGIONS_SET,
  REMOVE_NOTIFICATION,
  RESET_LIMIT,
  SET_GLOBAL_SETTING,
  SET_GLOBAL_SETTINGS,
  SET_JOBS,
  SET_NOTIFICATIONS,
  SHARE_SELECT,
  SHARES_SET,
  TOGGLE_USER_ACTIVE,
} from "./settingsActions";
const defaultState = {
  userListAdmin: [],
  notifications: [],
  globalSettings: {},
  selectedShare: null,
  shares: [],
  regions: [],
  forwardings: [],
  chartState: "",
};

const notifications = (state = [], action) => {
  switch (action.type) {
    case ADD_NOTIFICATION:
      return state.slice(0).concat([action.notification]);
    case REMOVE_NOTIFICATION:
      return state.slice(0).filter((n) => n.id !== action.id);
    default:
      return state;
  }
};

export default function (state = defaultState, action) {
  let actualState;
  switch (action.type) {
    case FORWARDINGS_SET:
      return {
        ...state,
        forwardings: action.forwardings,
      };
    case "ADD_ALLUSERS_ADMIN_SETTINGS":
      actualState = Object.assign({}, state);
      actualState.userListAdmin = action.userListAdmin;
      return actualState;
    case TOGGLE_USER_ACTIVE:
      return {
        ...state,
        userListAdmin: state.userListAdmin.map((u) => {
          if (u.userId === action.userId) {
            return {
              ...u,
              active: !u.active,
            };
          } else {
            return u;
          }
        }),
      };
    case RESET_LIMIT:
      return state;
    case SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.notifications,
      };
    case ADD_NOTIFICATION:
    case REMOVE_NOTIFICATION:
      return {
        ...state,
        notifications: notifications(state.notifications, action),
      };
    case SET_JOBS:
      return {
        ...state,
        jobs: action.jobs,
      };
    case SET_GLOBAL_SETTINGS:
      return {
        ...state,
        globalSettings: action.settings,
      };
    case SET_GLOBAL_SETTING:
      return {
        ...state,
        globalSettings: {
          ...state.globalSettings,
          [action.key]: action.value,
        },
      };
    case SHARES_SET:
      return {
        ...state,
        shares: action.shares,
      };
    case SHARE_SELECT:
      return {
        ...state,
        selectedShare: action.share,
      };
    case REGIONS_SET:
      return {
        ...state,
        regions: action.regions,
      };
    case CHART_STATE_SET:
      return {
        ...state,
        chartState: action.value,
      };
    case "LOGOUT":
      return defaultState;
    default:
      return state;
  }
}
